import * as Yup from 'yup';

export const validationSchema = Yup.object({
    first_name: Yup.string().required("First Name is required").max(30),
    last_name: Yup.string().required("Last Name is required").max(30),
    phone_number: Yup.string()
      .required("Phone number is required")
      .matches(
        /^\+\d{1,3}\d{10}$/,
        "Phone number must start with a '+' followed by the country code and exactly 10 digits"
      )
      .test(
        "is-numeric",
        "Phone number must be numeric",
        (value) => !isNaN(value.replace(/\+/g, ""))
      ),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/\d/, "Password must contain at least one number")
      .matches(
        /[@$!%*?&]/,
        "Password must contain at least one special character"
      ),
    confirm_password: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
    country: Yup.object()
      .required("Country is required")
      .nullable()
      .test(
        "valid-country",
        "Country must be a valid selection",
        (value) => value && value.label && value.value
      ),
    city: Yup.object()
      .required("City is required")
      .nullable()
      .test(
        "valid-city",
        "City must be a valid selection",
        (value) => value && value.label && value.value
      ),
    region: Yup.object().nullable(),
    address: Yup.string().required("Address is required").max(100),
    user_role: Yup.object()
      .required("User role is required")
      .nullable()
      .test(
        "valid-role",
        "User role must be a valid selection",
        (value) => value && value.label && value.value
      ),
  });
